module.exports = __webpack_public_path__ + "static/media/ZeroButtonClicked.5da622b8.svg";